import { c as _c } from "react/compiler-runtime";
interface SpinnerProps {
  size?: number;
}
const Spinner = t0 => {
  const $ = _c(3);
  const {
    size: t1
  } = t0;
  const size = t1 === undefined ? 42 : t1;
  const t2 = `w-[${size}px] p-2 aspect-square rounded-full bg-[#6B00D7] animate-[l3_1s_infinite_linear]`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      "--_m": "conic-gradient(#0000 10%,#000), linear-gradient(#000 0 0) content-box",
      WebkitMask: "var(--_m)",
      mask: "var(--_m)",
      WebkitMaskComposite: "source-out",
      maskComposite: "subtract"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== t2) {
    t4 = <div className={t2} style={t3 as React.CSSProperties} />;
    $[1] = t2;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  return t4;
};
export default Spinner;